import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const KEY = 'cot_return_to'
/** Authentication return destinations are local application routes, never external URLs. */
export function safeReturnPath(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\') || [...value].some((character) => character.charCodeAt(0) <= 32)) return
  try {
    const parsed = new URL(value, window.location.origin)
    if (parsed.origin !== window.location.origin) return
    if (!/^\/(?:$|invitations\/[A-Za-z0-9_-]+$|circles\/[A-Za-z0-9_-]+$|groups\/[A-Za-z0-9_-]+(?:\/observe)?$|rooms\/[A-Za-z0-9_-]+$|browse$|friends$|find$|family$|group-invitations$|report$|safety$|rules$|about$)/.test(parsed.pathname)) return
    return parsed.pathname + parsed.search + parsed.hash
  } catch { return }
}
export function pendingReturnPath(): string | undefined {
  try { return safeReturnPath(sessionStorage.getItem(KEY)) } catch { return }
}
export function rememberReturnPath(value: unknown) {
  const path = safeReturnPath(value)
  if (path) { try { sessionStorage.setItem(KEY, path) } catch { /* storage unavailable */ } }
}
export function consumeReturnPath(fallback = '/'): string {
  const path = pendingReturnPath() ?? fallback
  try { sessionStorage.removeItem(KEY) } catch { /* storage unavailable */ }
  return path
}
export function withReturnPath(route: string, returnTo?: string) {
  const path = safeReturnPath(returnTo)
  return path ? `${route}${route.includes('?') ? '&' : '?'}${new URLSearchParams({ returnTo: path })}` : route
}
export function useReturnDestination() {
  const location = useLocation()
  const target = safeReturnPath(new URLSearchParams(location.search).get('returnTo'))
    ?? safeReturnPath((location.state as { from?: unknown } | null)?.from)
    ?? pendingReturnPath()
  useEffect(() => { rememberReturnPath(target) }, [target])
  return target
}
